import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";

const team = [
  {
    name: "Sunita Jha",
    role: "Founder & Master Chandler",
    initials: "SJ",
    bio: "Passionate about crafting candles that bring warmth and fragrance into every home. Every SJ Aroma candle is poured with love in our Mumbai studio.",
  },
];

const values = [
  { icon: "🌿", title: "100% Natural Soy Wax",    desc: "We use only non-GMO soy wax sourced from Indian farms — clean burning, longer lasting, better for you." },
  { icon: "🧪", title: "No Toxic Additives",       desc: "Zero paraffin, zero synthetic dyes. Every candle is skin-safe and pet-friendly." },
  { icon: "♻️", title: "Zero-Waste Packaging",     desc: "All jars are reusable. Our wrapping is seed paper — plant it and watch wildflowers grow." },
  { icon: "🤝", title: "Artisan Made",             desc: "Small-batch production by hand. No two candles are exactly alike — each carries its maker's warmth." },
];

export default function About() {
  const navigate = useNavigate();

  return (
    <div style={{ background: "#faf7f2", minHeight: "100vh", paddingTop: "64px", fontFamily: "Georgia, serif" }}>

      {/* ── Hero ── */}
      <div
        className="relative w-full flex flex-col items-center justify-center text-center overflow-hidden"
        style={{ minHeight: "52vh", background: "linear-gradient(140deg, #1a0f00 0%, #2e1800 40%, #5a3800 80%, #c49a5a 100%)", padding: "80px 6%" }}
      >
        <div className="absolute pointer-events-none"
          style={{ right: "10%", top: "10%", width: "300px", height: "300px", borderRadius: "50%",
            background: "radial-gradient(ellipse, rgba(230,160,60,0.4) 0%, transparent 70%)", filter: "blur(40px)" }} />
        <p style={{ color: "#e0a060", fontSize: "11px", letterSpacing: "0.22em", textTransform: "uppercase", marginBottom: "16px" }}>
          Our Story
        </p>
        <h1 className="font-bold" style={{ fontSize: "clamp(32px, 5vw, 64px)", color: "#f5ede0", marginBottom: "20px", maxWidth: "700px", lineHeight: "1.1" }}>
          Born from a Love of <em style={{ color: "#e8a855" }}>Warmth</em>
        </h1>
        <p style={{ fontSize: "clamp(13px, 1.3vw, 15px)", color: "rgba(245,237,224,0.72)", maxWidth: "480px", lineHeight: "1.8" }}>
          SJ Aroma Candles started as a kitchen experiment in Mumbai and grew into India's most loved artisan candle brand — one handcrafted batch at a time.
        </p>
        <style>{`@keyframes fadeUp { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }`}</style>
      </div>

      {/* ── Origin story ── */}
      <section style={{ padding: "80px 6%", maxWidth: "900px", margin: "0 auto", textAlign: "center" }}>
        <div style={{ width: "40px", height: "2px", background: "#e07b39", margin: "0 auto 24px" }} />
        <h2 className="font-bold" style={{ fontSize: "clamp(20px, 2.5vw, 28px)", color: "#1a1a1a", marginBottom: "20px" }}>
          Why We Started
        </h2>
        <p style={{ fontSize: "15px", color: "#5a4030", lineHeight: "1.9", marginBottom: "16px" }}>
          It began with a simple question: <em>"Why does every candle smell the same?"</em> Our founder Sunita had grown up burning cheap paraffin candles
          that left soot on the walls and a chemical headache. She decided to make something different — a candle that smelled like the rain on
          Bombay's streets, or the sandalwood in her grandmother's cupboard.
        </p>
        <p style={{ fontSize: "15px", color: "#5a4030", lineHeight: "1.9" }}>
          Today, every SJ Aroma candle is still hand-poured in our Mumbai studio using 100% natural soy wax and botanically inspired fragrance oils.
          No shortcuts. No compromises. Just the warmth of a flame done right.
        </p>
      </section>

      {/* ── Values grid ── */}
      <section style={{ background: "#fff", padding: "80px 6%" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <div className="text-center" style={{ marginBottom: "48px" }}>
            <h2 className="font-bold" style={{ fontSize: "clamp(20px, 2.5vw, 28px)", color: "#1a1a1a", marginBottom: "8px" }}>What We Stand For</h2>
            <div style={{ width: "40px", height: "2px", background: "#e07b39", margin: "0 auto" }} />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {values.map(({ icon, title, desc }) => (
              <div key={title} style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
                <div style={{ width: "48px", height: "48px", borderRadius: "12px", background: "rgba(224,123,57,0.1)",
                  display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", flexShrink: 0 }}>
                  {icon}
                </div>
                <div>
                  <div className="font-semibold" style={{ fontSize: "15px", color: "#1a1a1a", marginBottom: "6px" }}>{title}</div>
                  <div style={{ fontSize: "13px", color: "#888", lineHeight: "1.7" }}>{desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Team — only Sunita Jha ── */}
      <section style={{ background: "#faf7f2", padding: "80px 6%" }}>
        <div style={{ maxWidth: "500px", margin: "0 auto" }}>
          <div className="text-center" style={{ marginBottom: "48px" }}>
            <h2 className="font-bold" style={{ fontSize: "clamp(20px, 2.5vw, 28px)", color: "#1a1a1a", marginBottom: "8px" }}>Meet the Maker</h2>
            <div style={{ width: "40px", height: "2px", background: "#e07b39", margin: "0 auto" }} />
          </div>
          {team.map(({ name, role, initials, bio }) => (
            <div key={name} className="text-center">
              <div style={{ width: "88px", height: "88px", borderRadius: "50%",
                background: "linear-gradient(135deg, #e07b39, #c96a28)", color: "#fff",
                fontFamily: "Georgia, serif", fontSize: "26px", fontWeight: "700",
                display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px",
                boxShadow: "0 8px 28px rgba(224,123,57,0.35)" }}>
                {initials}
              </div>
              <div className="font-bold" style={{ fontSize: "20px", color: "#1a1a1a", marginBottom: "6px" }}>{name}</div>
              <div style={{ fontSize: "11px", color: "#e07b39", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: "16px" }}>{role}</div>
              <div style={{ fontSize: "14px", color: "#888", lineHeight: "1.8", maxWidth: "380px", margin: "0 auto" }}>{bio}</div>
            </div>
          ))}
        </div>
      </section>


      {/* ── Crafted Just for You ── */}
      <section style={{ background: "linear-gradient(135deg, #2d1f0e 0%, #1a1a1a 60%, #2d1a00 100%)", padding: "80px 6%", position: "relative", overflow: "hidden" }}>

        {/* Background glow effects */}
        <div style={{ position: "absolute", top: "-60px", right: "-60px", width: "320px", height: "320px", borderRadius: "50%",
          background: "radial-gradient(ellipse, rgba(224,123,57,0.18) 0%, transparent 70%)", filter: "blur(40px)", pointerEvents: "none" }} />
        <div style={{ position: "absolute", bottom: "-40px", left: "-40px", width: "240px", height: "240px", borderRadius: "50%",
          background: "radial-gradient(ellipse, rgba(224,123,57,0.12) 0%, transparent 70%)", filter: "blur(30px)", pointerEvents: "none" }} />

        <div style={{ maxWidth: "820px", margin: "0 auto", position: "relative", zIndex: 1 }}>

          {/* Top label */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px", marginBottom: "24px" }}>
            <div style={{ height: "1px", flex: 1, background: "linear-gradient(90deg, transparent, rgba(224,123,57,0.5))" }} />
            <span style={{ fontFamily: "Georgia, serif", fontSize: "10px", color: "#e07b39", letterSpacing: "0.28em", textTransform: "uppercase", whiteSpace: "nowrap" }}>
              🕯️ Special Feature
            </span>
            <div style={{ height: "1px", flex: 1, background: "linear-gradient(90deg, rgba(224,123,57,0.5), transparent)" }} />
          </div>

          {/* Main card */}
          <div style={{ background: "rgba(255,255,255,0.05)", border: "1.5px solid rgba(224,123,57,0.4)", borderRadius: "24px", padding: "48px 52px",
            boxShadow: "0 0 60px rgba(224,123,57,0.12), inset 0 1px 0 rgba(255,255,255,0.06)" }}>

            <h2 style={{ fontFamily: "Georgia, serif", fontSize: "clamp(24px, 3vw, 36px)", fontWeight: "700", color: "#fff",
              marginBottom: "24px", textAlign: "center", lineHeight: "1.2" }}>
              Crafted <em style={{ color: "#e8a855", fontStyle: "italic" }}>Just for You</em>
            </h2>

            {/* Highlight bar */}
            <div style={{ width: "60px", height: "3px", background: "linear-gradient(90deg, #e07b39, #e8a855)", borderRadius: "999px", margin: "0 auto 28px" }} />

            <p style={{ fontFamily: "Georgia, serif", fontSize: "15px", color: "rgba(245,237,224,0.85)", lineHeight: "1.95",
              textAlign: "center", marginBottom: "20px", maxWidth: "680px", marginLeft: "auto", marginRight: "auto" }}>
              At SJ Aroma, we believe every candle can tell a personal story. That's why we specialize in customized
              creations tailored to your unique needs. Whether it's a special gift, a celebration, or a personal touch
              for your space, you can share your ideas with us through the customization section.
            </p>

            <p style={{ fontFamily: "Georgia, serif", fontSize: "15px", color: "rgba(245,237,224,0.85)", lineHeight: "1.95",
              textAlign: "center", marginBottom: "36px", maxWidth: "680px", marginLeft: "auto", marginRight: "auto" }}>
              From design and color to fragrance and theme, we carefully craft each piece and deliver it to your
              doorstep within <strong style={{ color: "#e8a855" }}>5–6 days</strong> — handmade with the same warmth
              and love that defines every SJ Aroma candle.
            </p>

            {/* Feature pills */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center", marginBottom: "36px" }}>
              {["🎨 Custom Design", "🌸 Choose Fragrance", "🎁 Perfect Gifting", "🚚 5–6 Day Delivery", "💛 Handmade with Love"].map(tag => (
                <span key={tag} style={{ fontFamily: "Georgia, serif", fontSize: "12px", color: "#e8a855",
                  background: "rgba(224,123,57,0.15)", border: "1px solid rgba(224,123,57,0.3)",
                  borderRadius: "999px", padding: "6px 16px", letterSpacing: "0.04em" }}>
                  {tag}
                </span>
              ))}
            </div>

            {/* CTA button */}
            <div style={{ textAlign: "center" }}>
              <button
                onClick={() => { window.location.href = "/#customize"; setTimeout(() => { document.getElementById("customize")?.scrollIntoView({ behavior: "smooth" }); }, 300); }}
                style={{ padding: "14px 40px", borderRadius: "999px", background: "linear-gradient(135deg, #e07b39, #c96a18)",
                  color: "#fff", border: "none", cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "13px",
                  fontWeight: "700", letterSpacing: "0.1em", boxShadow: "0 6px 28px rgba(224,123,57,0.45)",
                  transition: "all 0.2s" }}
                onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}>
                🕯️ Customise Your Candle
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ background: "linear-gradient(140deg, #1a0f00, #3d2200)", padding: "80px 6%", textAlign: "center" }}>
        <p style={{ color: "#e0a060", fontSize: "11px", letterSpacing: "0.2em", textTransform: "uppercase", marginBottom: "16px" }}>
          Ready to Begin?
        </p>
        <h2 className="font-bold" style={{ fontSize: "clamp(22px, 3vw, 36px)", color: "#f5ede0", marginBottom: "20px" }}>
          Find Your Signature Scent
        </h2>
        <p style={{ color: "rgba(245,237,224,0.65)", fontSize: "14px", marginBottom: "32px",
          maxWidth: "420px", margin: "0 auto 32px", lineHeight: "1.8" }}>
          Every home deserves a candle made just for it. Explore our full collection.
        </p>
        <button onClick={() => navigate("/products")}
          className="rounded-full text-xs font-semibold uppercase transition-all duration-300"
          style={{ padding: "14px 36px", background: "#e07b39", color: "#fff", border: "none",
            cursor: "pointer", fontFamily: "Georgia, serif", letterSpacing: "0.1em",
            boxShadow: "0 6px 24px rgba(224,123,57,0.45)" }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#c96a28")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "#e07b39")}>
          Shop the Collection
        </button>

        {/* Contact line */}
        <p style={{ color: "rgba(245,237,224,0.7)", fontFamily: "Georgia, serif", fontSize: "13px",
          marginTop: "32px", lineHeight: "1.8" }}>
          For any queries, contact us directly —{" "}
          <a href="tel:+917021916502" style={{ color: "#e8a855", textDecoration: "none", fontWeight: "600" }}>
            +91 70219 16502
          </a>
          {" "}/ +91 98928 64936
        </p>
      </section>

      <Footer />
    </div>
  );
}